import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { OrganizationUnit } from '../../../misc/interface/organization-unit'
import { FilterService, SelectItem } from 'primeng/api';
import { DataView } from 'primeng/dataview';

import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { NavigationEnd, Router } from '@angular/router';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { CryptoService } from 'src/app/services/crypto.service';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

@Component({
  selector: 'app-home-entities',
  templateUrl: './home-entities.component.html',
  styleUrls: ['./home-entities.component.scss']
})
export class HomeEntitiesComponent {
onMouseLeave(event: MouseEvent,entity: any) {
  const target = event.relatedTarget as HTMLElement;
  const parent = event.currentTarget as HTMLElement;

  // Check if the mouse is leaving the parent container
  if (!parent.contains(target)) {
    this.entityHover[entity.id] = false;
  }
}
onMouseEnter(entity: any) {
  this.entityHover[entity.id] = true; this.mouseenterthingy(entity)
}
  mouseenter() {
    console.log("ENTER")
  }


  entityHover: any[] = []


  entities: OrganizationUnit[] = [];

  filteredData: OrganizationUnit[] = [];

  layout: string = 'list';

  sortOptions: SelectItem[] = [];

  sortOrder: number = 1;

  sortField: string = 'score';

  skelition: boolean = true

  current: OrganizationUnit | undefined;
  currentChildren: any[] = [];

  tags: any[] = [
    "Ministries/Entities",
    "Organisational Units"
  ]
  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || 'false');
  showChildren: boolean = false;
  @Output() licenseOus: EventEmitter<any> = new EventEmitter<any>();
  sortKey: any;

  @ViewChild('dv')
  dv!: DataView;

  entitytype = 'all';

  allowedOus: any[] = []

  staticURL = GlobalConstants.staticFilesURL;
  uniqueTypeNames: Set<string> = new Set();
  translator: TranslatorPipe = new TranslatorPipe()
  constructor(
    private filterService: FilterService,
    private dataService: DataService,
    private router: Router,
    private cryptoService: CryptoService,
    private ouService: OrgUnitsService,
    public permissionService: PermissionHandlerService,
  ) { }

  async fetchOUS() {
    this.allowedOus = await this.permissionService.extractOUChildren('CONTENT', 'r');
    console.log('OUS', this.allowedOus);
  }

  ngOnInit() {
        this.runingFunction();
  }


  runingFunction() {
    this.fetchOUS().then(async () => {
      this.getEntities().then((data: any) => {
        this.skelition = false;
        this.entities = data;
        this.filterTreeData(this.entities);
        this.filteredData = this.entities;
        // this.entities = this.entities.filter((item)=> { return item.type?.name != "Ou"})
        this.exportOus();
        this.sortOptions = [
          { label: this.translate('Services'), value: "data_object['الخدمات']", icon: 'pi pi-file pi-fw' },
          { label: this.translate('common questions'), value: 'data_object["الأسئلة الشائعة"]', icon: "pi pi-question pi-fw" },
          { label: this.translate('Economic activities'), value: 'data_object.isic', icon: "pi pi-building pi-fw" },
          { label: this.translate('Closed cases'), value: 'data_object.licence', icon: "pi pi-briefcase pi-fw" },
          { label: this.translate('Knowledge Library'), value: 'data_object.library', icon: "pi pi-book pi-fw" },
        ];

        // Assuming this.filteredData contains the data
        // Define a Set to store unique type names
        const uniqueTypeNames = new Set<string>();

        // Iterate through this.filteredData to collect unique type names
        this.filteredData.forEach((orgUnit: OrganizationUnit) => {
          // Check if the orgUnit has the correct type.tag
          if (orgUnit.type && orgUnit.type.tag === "Ministries/Entities") {
            // Add the type.name to the Set
            if (orgUnit.type && orgUnit.type.name) {
              uniqueTypeNames.add(orgUnit.type.name);
            }
          }
        });

        this.uniqueTypeNames = uniqueTypeNames;

      });
    });
  }


  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }


  filterTreeData(nodes: any[]): void {
    for (let i = nodes.length - 1; i >= 0; i--) {
      const node = nodes[i];
      if (this.tags.includes(node.type!.tag!)) {
        // Node matches the filter tag, keep it
        if (node.children) {
          this.filterTreeData(node.children);
        }
      } else {
        nodes.splice(i, 1);
      }
    }
  }

  exportOus() {
    let entities = this.entities.filter((entity: any) => entity.data_counter.length != 0);
    this.licenseOus.emit(entities);
  }

  navigateToResult(ou: any) {
    // let query: any = {
    //   condition: 'and',
    //   rules: [],
    //   extras: { ou: ou.id }
    // };
    // let encryptedQuery = this.cryptoService.encodeObject(query);
    let queryParams = { ou: ou.id, searchTerm: 'all' };
    this.router.navigate(['/search-view'], { queryParams });
  }


  handleClick(open: boolean, category: OrganizationUnit) {

    console.log("cat", category.children);

    this.currentChildren = this.getWithService(category.children ?? []);

    if (open || this.currentChildren.length == 0) {
      this.navigateToResult(category);
    } else {
      if (this.current?._id == category._id && this.showChildren) {
        // this.showChildren = false
        // this.current = undefined;
        // this.currentChildren = [];
        this.navigateToResult(category);
      } else {
        this.current = category;
        this.currentChildren = this.getWithService(this.current.children ?? []);
        this.showChildren = true;
      }
    }
  }

  mouseenterthingy(category: any) {

    this.mouseenter();

    console.log("cat", category.children);

    this.currentChildren = this.getWithService(category.children ?? []);

    if (this.currentChildren.length == 0) {
      this.showChildren = false
    } else {
      if (this.current?._id == category._id && this.showChildren) {
        this.showChildren = false
      } else {
        this.current = category;
        this.currentChildren = this.getWithService(this.current?.children ?? []);
        this.showChildren = true;
      }
    }

    // if (this.current?.children !== undefined) {
    //   this.current = category;
    //   this.currentChildren = this.getWithService(this.current?.children ?? []);
    //   this.showChildren = true;
    // }


    // if (this.currentChildren.length != 0) {
    //   if (this.current && this.current._id == category._id && this.showChildren) {
    //     this.showChildren = true
    //   } else {
    //     this.showChildren = false;
    //   }
    // } else {
    //   this.showChildren = false
    // }

  }

  OpenServicesPage(ouid: string, type: string) {

    console.log('/list-services/', ouid, '/', type);

    const link: string = '/list-services/' + ouid + '/' + type;

    this.router.navigate([link]);
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false
    }
  }

  getWithService(data: any) {
    //console.log("this data", data);
    return data.filter((e: any) => e.data_counter && e.data_counter.length > 0);
  }

  getCardClass(length: number) {
    if (length > 2) {
      return 'col-lg-2 col-md-2 col-sm-6'
    } else {
      if (length == 1) {
        return 'col-10'
      }
      return 'col-4'
    }
  }

  async getEntities() {
    try {

      let response = await this.dataService.getData("ou/parent");
      if (this.isLoggedIn) {
        return response.data
          .filter((e: any) => this.permissionService.all.includes(e._id));
      } else {
        return response.data
          .filter((e: any) =>  {

            let a = this.permissionService.payload.content.allOus.all.includes(e._id);
            let b = this.permissionService.payload.content.signedOus.all.includes(e._id);
            let c_count = e?.data_counter.reduce((accumulator: any, current: { signed: any; }) => {
              return accumulator + current.signed;
          }, 0);
            let c= c_count > 0

            if(b) console.log("CONDITION",b,c,c_count);

            return (a || (b && c ));
          }
        );
            
      }

    } catch (error) {
      console.log(error)
    }

  }



  onSortChange(event: { value: any; }) {
    let value = event.value;

    if (value.indexOf('!') === 0) {
      this.sortOrder = -1;
      this.sortField = value.substring(1, value.length);
      console.log(this.sortField);
    } else {
      this.sortOrder = 1;
      this.sortField = value;
    }
  }

  toArabic(word: string) {
    switch (word) {
      case 'entity':
        return 'كيانات أخرى';

      case 'ministry':
        return 'الوزارات';

      default:
        return null;
    }
  }

  applyFilterGlobal(event: any) {
    let query = event.target.value;
    this.filteredData = this.entities;
    if (query) {
      this.filteredData = this.filteredData.filter((d: any) => {
        let res = this.searchValue(d, query);
        return res;
      })
    }
  }

  public searchValue(obj: any, targetValue: any): boolean {
    for (const key in obj) {
      const value = obj[key];

      if (value === targetValue) {
        return true;
      }

      if (typeof value == 'string' && value.includes(targetValue)) {
        return true;
      }

      if (typeof value === 'object' && value !== null) {
        if (Array.isArray(value)) {
          for (const item of value) {
            if (this.searchValue(item, targetValue)) {
              return true;
            }
          }
        } else {
          if (this.searchValue(value, targetValue)) {
            return true;
          }
        }
      }
    }

    return false;
  }

  applyTypeFilter(value: any) {
    console.log(value);
    if (value == 'all') {
      this.dv.filter('', 'contains')
    } else {
      this.dv.filter(value, 'equals')
    }
  }

  dataSorter(
    dataCounter: { _id: string; count: number; signed: number; icon: string }[],
    e: any
  ): any[] {
    const orderArray = ["الخدمات", "الأسئلة الشائعة"];
  
    const sortFunction = (a: { _id: string }, b: { _id: string }) => {
      const aIndex = orderArray.indexOf(a._id);
      const bIndex = orderArray.indexOf(b._id);
  
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
  
      if (aIndex !== -1) {
        return -1;
      }
      if (bIndex !== -1) {
        return 1;
      }
  
      return a._id.localeCompare(b._id);
    };
  
    if (this.isLoggedIn) {
      dataCounter.sort(sortFunction);
      return dataCounter;
    } else {
      const allOusIncludes = this.permissionService.payload.content.allOus.all.includes(e);
      const signedOusIncludes = this.permissionService.payload.content.signedOus.all.includes(e);
  
      if (allOusIncludes) {
        dataCounter.sort(sortFunction);
        return dataCounter;
      } else if (signedOusIncludes) {
        dataCounter = dataCounter.filter((data) => data.signed !== 0);
        dataCounter.forEach((data) => {
          data.count = data.signed;
        });
        dataCounter.sort(sortFunction);
        return dataCounter;
      }
    }
  
    return dataCounter;
  }
  

}
